import { render, staticRenderFns } from "./main-story-cards.vue?vue&type=template&id=408814d4&scoped=true"
import script from "./main-story-cards.vue?vue&type=script&lang=js"
export * from "./main-story-cards.vue?vue&type=script&lang=js"
import style0 from "./main-story-cards.vue?vue&type=style&index=0&id=408814d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408814d4",
  null
  
)

export default component.exports